<template>
    <div>
        <h5>Adresse de tenue de comptabilité</h5>

        <p v-if="'other' != socialCertificate.accounting_address.same_as_existing_address">
            <strong>Identique à :</strong>
            {{ socialCertificate.accounting_address.decoded_same_as_existing_address }}
        </p>

        <ul v-else>
            <li v-if="socialCertificate.accounting_address.corporation_name">
                {{ socialCertificate.accounting_address.corporation_name }}
            </li>
            <li v-if="socialCertificate.accounting_address.first_name || socialCertificate.accounting_address.last_name">
                {{ socialCertificate.accounting_address.first_name }} {{ socialCertificate.accounting_address.last_name }}
            </li>
            <li>
                {{ socialCertificate.accounting_address.street_line1 }}
            </li>
            <li v-if="socialCertificate.accounting_address.street_line2">
                {{ socialCertificate.accounting_address.street_line2 }}
            </li>
            <li>
                {{ socialCertificate.accounting_address.zipcode }} {{ socialCertificate.accounting_address.city }}
            </li>
            <li v-if="socialCertificate.accounting_address.decoded_state">
                {{ socialCertificate.accounting_address.decoded_state }}
            </li>
            <li v-if="socialCertificate.accounting_address.decoded_country">
                {{ socialCertificate.accounting_address.decoded_country }}
            </li>
        </ul>

        <h5>Adresse de tenue des documents sociaux</h5>

        <p v-if="'other' != socialCertificate.social_address.same_as_existing_address">
            <strong>Identique à :</strong>
            {{ socialCertificate.social_address.decoded_same_as_existing_address }}
        </p>

        <ul v-else>
            <li v-if="socialCertificate.social_address.corporation_name">
                {{ socialCertificate.social_address.corporation_name }}
            </li>
            <li v-if="socialCertificate.social_address.first_name || socialCertificate.social_address.last_name">
                {{ socialCertificate.social_address.first_name }} {{ socialCertificate.social_address.last_name }}
            </li>
            <li>
                {{ socialCertificate.social_address.street_line1 }}
            </li>
            <li v-if="socialCertificate.social_address.street_line2">
                {{ socialCertificate.social_address.street_line2 }}
            </li>
            <li>
                {{ socialCertificate.social_address.zipcode }} {{ socialCertificate.social_address.city }}
            </li>
            <li v-if="socialCertificate.social_address.decoded_state">
                {{ socialCertificate.social_address.decoded_state }}
            </li>
            <li v-if="socialCertificate.social_address.decoded_country">
                {{ socialCertificate.social_address.decoded_country }}
            </li>
        </ul>

        <h5>Salarié(s)</h5>

        <table class="table">
            <tbody>
                <tr>
                    <td>N'emploie aucun salarié</td>
                    <td>
                        <input type="checkbox" :checked="socialCertificate.customer.without_employee" onclick="return false;">
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="buttons clearfix">
            <button class="btn btn-default btn-sm"
                @click="$emit('current-step-changed', 'customer-employees')"
            >
                Précédent
            </button>

            <button class="btn btn-success btn-sm pull-right"
                @click="$emit('form-validated')"
            >
                Mettre à jour
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            socialCertificate: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .table {
        tbody {
            tr {
                td {
                    padding: 5px;
                    border: 0;

                    ul {
                        padding:0;
                        li {
                            list-style-type: none;
                        }
                    }
                }
            }

            tr.text-danger {
                td {
                    color: inherit;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/SocialCertificate/EditionForm/FormSummaryStep.vue